import { Row, Col, Breadcrumb } from "react-bootstrap";
import { IComplianceInvestigationActionOrInstructionDetails } from "../../../../api/ComplianceInvestigation/IComplianceInvestigationActionsAndInstructions";
import { ILicenceProfile } from "../../../../api/ILicenceProfile";

interface BreadcrumbProps {
  licenceProfile: ILicenceProfile;
  actionOrInstruction: IComplianceInvestigationActionOrInstructionDetails;
}

const BreadCrumbs = ({
  licenceProfile,
  actionOrInstruction,
}: BreadcrumbProps) => (
  <Row>
    <Col xs="12">
      <Breadcrumb className="leap">
        <Breadcrumb.Item href="/">LEAP Online Home</Breadcrumb.Item>
        <Breadcrumb.Item href={`/licence-profile/${licenceProfile.profileNo}`}>
          {licenceProfile.organisation} - {licenceProfile.profileNo}
        </Breadcrumb.Item>
        <Breadcrumb.Item
          href={`/licence-profile/${licenceProfile.profileNo}/compliance`}
        >
          Compliance
        </Breadcrumb.Item>
        <Breadcrumb.Item
          href={`/licence-profile/${licenceProfile.profileNo}/compliance/investigation/${actionOrInstruction.regardingobjectid}`}
        >
          {actionOrInstruction.complianceInvestidationDetails?.reference}
        </Breadcrumb.Item>
        <Breadcrumb.Item active>
          {actionOrInstruction.reference}
        </Breadcrumb.Item>
      </Breadcrumb>
    </Col>
  </Row>
);

export default BreadCrumbs;
